import React, { useState, useRef, useCallback } from "react";
import { Tag, Typography, Input, Button, Tabs } from "antd";
import { SearchOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleReconA from "./sampleReconA.json";
import sampleReconB from "./sampleReconB.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";

const ToolParamInvoker = (params) => {
  const { value, handleClick, label, data, colDef } = params;
  console.log("Invoice Data:", data);
  console.log("Handle Click in ToolParamInvoker:", handleClick);

  // Get the field dynamically from colDef
  const fieldKey = colDef?.field;
  //const invoiceLink = data?.[fieldKey];
  const invoiceLink = data?.[colDef?.field] || "";
  console.log("Field Key:", fieldKey);
  console.log("Data Object:", data);
  console.log("Extracted Invoice Link:", invoiceLink);

  const onLinkClick = useCallback(
    (e) => {
      e.stopPropagation();
      console.log(handleClick, "handleClick");
      if (handleClick && invoiceLink) {
        handleClick(params, { pdfData: invoiceLink });
      }
    },
    [handleClick, params, invoiceLink]
  );

  return (
    <div onClick={onLinkClick} title={value}>
      <div
        role="button"
        className="link-primary text-truncate"
        style={{
          cursor: invoiceLink ? "pointer" : "default",
          color: invoiceLink ? "blue" : "gray",
        }}
      >
        {invoiceLink ? "View Invoice" : "No Invoice"}
      </div>
    </div>
  );
};

// const openSidebarRenderer = (params) => {
//   console.log(params?.data?.["airlineInvoiceLink"]);
//   params.api.openToolPanel("pdfRenderer", {
//     paramData: params?.data?.["airlineInvoiceLink"],
//   });
// };

const columnDefs1 = [
  {
    field: "airlineInvoiceLink",
    headerName: "Airline Invoice Link",
    filter: true,
    cellRenderer: (params) => {
      return (
        <Button
          size="small"
          onClick={() => window.open(params.data?.airlineInvoiceLink, "_blank")}
        >
          View Invoice
        </Button>
      );
    },
  },
  {
    field: "agencyInvoiceLink",
    headerName: "Agency Invoice Link",
    filter: true,
    cellRenderer: (params) => {
      return (
        <Button
          size="small"
          onClick={() => window.open(params.data?.agencyInvoiceLink, "_blank")}
        >
          View Invoice
        </Button>
      );
    },
  },
  { field: "ctaWBStatus", headerName: "CTA-WB Status", filter: true },
  {
    field: "ctaWithBookingStatus",
    headerName: "CTA with Booking Status",
    filter: true,
  },
  {
    field: "ctaAgencyAmountDiff",
    headerName: "CTA - Agency Amount Diff",
    filter: true,
  },

  {
    headerName: "CC Details",
    children: [
      {
        field: "ccDetails.cardNumber",
        headerName: "Card Number",
        filter: true,
      },
      {
        field: "ccDetails.approvalCode",
        headerName: "Approval Code",
        filter: true,
      },
      {
        field: "ccDetails.postingDate",
        headerName: "Posting Date",
        filter: true,
      },
      {
        field: "ccDetails.merchantName",
        headerName: "Merchant Name",
        filter: true,
      },
      {
        field: "ccDetails.debitCreditCode",
        headerName: "Debit/Credit Code",
        filter: true,
      },
      {
        field: "ccDetails.transactionAmount",
        headerName: "Transaction Amount",
        filter: true,
      },
      {
        field: "ccDetails.travelAgencyInvoiceNumber",
        headerName: "Travel Agency Invoice No.",
        filter: true,
      },
    ],
  },

  {
    headerName: "WA Details",
    children: [
      { field: "waDetails.docNumber", headerName: "Doc Number", filter: true },
      { field: "waDetails.docDate", headerName: "Doc Date", filter: true },
      {
        field: "waDetails.customerId",
        headerName: "Customer ID",
        filter: true,
      },
      {
        field: "waDetails.customerName",
        headerName: "Customer Name",
        filter: true,
      },
      {
        field: "waDetails.grossAmountCCC",
        headerName: "Gross Amount CCC",
        filter: true,
      },
    ],
  },

  {
    headerName: "Booking Client Specifics",
    children: [
      {
        field: "bookingClientSpecifics.customerNumber",
        headerName: "Customer Number",
        filter: true,
      },
    ],
  },

  {
    headerName: "Booking Level I - Financial Details",
    children: [
      {
        field: "bookingLevel1FinancialDetails.documentNumber",
        headerName: "Document Number",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.documentDate",
        headerName: "Document Date",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.fareComponents.basic",
        headerName: "Basic Fare",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.fareComponents.YQ",
        headerName: "YQ",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.fareComponents.YR",
        headerName: "YR",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.fareComponents.K3",
        headerName: "K3",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.fareComponents.OT",
        headerName: "OT",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.serviceFee",
        headerName: "Service Fee",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.processingFees",
        headerName: "Processing Fees",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.cgst",
        headerName: "CGST",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.sgst",
        headerName: "SGST",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.igst",
        headerName: "IGST",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.discount",
        headerName: "Discount",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.airlineCancellationCharge",
        headerName: "Airline Cancellation Charge",
        filter: true,
      },
      {
        field: "bookingLevel1FinancialDetails.totalAmount",
        headerName: "Total Amount",
        filter: true,
      },
    ],
  },

  {
    headerName: "Booking Level II - Operational Details",
    children: [
      {
        field: "bookingLevel2OperationalDetails.passengerName",
        headerName: "Passenger Name",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.travelType",
        headerName: "Type of Travel Service",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.gdsPnr",
        headerName: "GDS PNR",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.ticketNumber",
        headerName: "Ticket Number",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.sector",
        headerName: "Sector",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.airline",
        headerName: "Airline",
        filter: true,
      },
      {
        field: "bookingLevel2OperationalDetails.travelDate",
        headerName: "Travel Date",
        filter: true,
      },
    ],
  },

  {
    headerName: "Booking Level III - Extended Data",
    children: [
      {
        field: "bookingLevel3ExtendedData.bkTrNo",
        headerName: "BK TR No.",
        filter: true,
      },
      {
        field: "bookingLevel3ExtendedData.empNo",
        headerName: "Employee Number",
        filter: true,
      },
      {
        field: "bookingLevel3ExtendedData.department",
        headerName: "Department",
        filter: true,
      },
      {
        field: "bookingLevel3ExtendedData.orderNo",
        headerName: "Order Number",
        filter: true,
      },
      {
        field: "bookingLevel3ExtendedData.costCentre",
        headerName: "Cost Centre",
        filter: true,
      },
      {
        field: "bookingLevel3ExtendedData.tripReason",
        headerName: "Trip Reason",
        filter: true,
      },
    ],
  },

  {
    headerName: "Airline Invoice Details",
    children: [
      {
        field: "airlineInvoiceDetails.invoiceNumber",
        headerName: "Invoice Number",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.invoiceDate",
        headerName: "Invoice Date",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.documentType",
        headerName: "Document Type",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.customerGSTIN",
        headerName: "Customer GSTIN",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.customerPAN",
        headerName: "Customer PAN",
        filter: true,
      },
      { field: "airlineInvoiceDetails.igst", headerName: "IGST", filter: true },
      { field: "airlineInvoiceDetails.cgst", headerName: "CGST", filter: true },
      { field: "airlineInvoiceDetails.sgst", headerName: "SGST", filter: true },
      {
        field: "airlineInvoiceDetails.totalGST",
        headerName: "Total GST",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.taxRate",
        headerName: "Tax Rate (%)",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.origin",
        headerName: "Origin",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.taxableAmount",
        headerName: "Taxable Amount",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.nonTaxableAmount",
        headerName: "Non-Taxable Amount",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.hsnSacCode",
        headerName: "HSN/SAC Code",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.totalAmount",
        headerName: "Total Invoice Amount",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.ticketPNR",
        headerName: "Ticket/PNR",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.vendor",
        headerName: "Vendor",
        filter: true,
      },
      {
        field: "airlineInvoiceDetails.supplierGSTIN",
        headerName: "Supplier GSTIN",
        filter: true,
      },
    ],
  },

  {
    headerName: "Agency Invoice Details",
    children: [
      {
        field: "agencyInvoiceDetails.docNumber",
        headerName: "Doc Number",
        filter: true,
      },
      {
        field: "agencyInvoiceDetails.docDate",
        headerName: "Doc Date",
        filter: true,
      },
      {
        field: "agencyInvoiceDetails.agencyGSTIN",
        headerName: "Agency GSTIN",
        filter: true,
      },
      {
        field: "agencyInvoiceDetails.customerGSTIN",
        headerName: "Customer GSTIN",
        filter: true,
      },
      {
        field: "agencyInvoiceDetails.taxableAmount",
        headerName: "Taxable Amount",
        filter: true,
      },
      { field: "agencyInvoiceDetails.igst", headerName: "IGST", filter: true },
      { field: "agencyInvoiceDetails.cgst", headerName: "CGST", filter: true },
      { field: "agencyInvoiceDetails.sgst", headerName: "SGST", filter: true },
      {
        field: "agencyInvoiceDetails.totalGST",
        headerName: "Total GST",
        filter: true,
      },
      {
        field: "agencyInvoiceDetails.totalInvoiceAmount",
        headerName: "Total Invoice Amount",
        filter: true,
      },
    ],
  },
];
const columnDefs2 = [
  // CT fields
  {
    headerName: "CT-FIN.APPROVAL CODE",
    field: "CT-FIN.APPROVAL CODE",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT-FIN.APPROVAL CODE"],
  },
  {
    headerName: "CT - FIN.POSTING DATE",
    field: "CT - FIN.POSTING DATE",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.POSTING DATE"],
  },
  {
    headerName: "CT - FIN.TRANSACTION DATE",
    field: "CT - FIN.TRANSACTION DATE",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.TRANSACTION DATE"],
  },
  {
    headerName: "CT - MCH.MERCHANT NAME",
    field: "CT - MCH.MERCHANT NAME",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - MCH.MERCHANT NAME"],
  },
  {
    headerName: "CT - FIN.TRANSACTION DESCRIPTION",
    field: "CT - FIN.TRANSACTION DESCRIPTION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.TRANSACTION DESCRIPTION"],
  },
  {
    headerName: "CT - FIN.ORIGINAL ISO CURRENCY CODE SYMBOL",
    field: "CT - FIN.ORIGINAL ISO CURRENCY CODE SYMBOL",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.ORIGINAL ISO CURRENCY CODE SYMBOL"],
  },
  {
    headerName: "CT - FIN.POSTED ISO CURRENCY CODE SYMBOL",
    field: "CT - FIN.POSTED ISO CURRENCY CODE SYMBOL",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.POSTED ISO CURRENCY CODE SYMBOL"],
  },
  {
    headerName: "CT - FIN.DEBIT CREDIT CODE",
    field: "CT - FIN.DEBIT CREDIT CODE",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.DEBIT CREDIT CODE"],
  },
  {
    headerName: "CT - FIN.ORIGINAL CURRENCY CODE",
    field: "CT - FIN.ORIGINAL CURRENCY CODE",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.ORIGINAL CURRENCY CODE"],
  },
  {
    headerName: "CT - FIN.ORIGINAL CURRENCY AMOUNT",
    field: "CT - FIN.ORIGINAL CURRENCY AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.ORIGINAL CURRENCY AMOUNT"],
  },
  {
    headerName: "CT - FIN.TRANSACTION AMOUNT",
    field: "CT - FIN.TRANSACTION AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.TRANSACTION AMOUNT"],
  },
  {
    headerName: "CT - PT.AIR.FARE AMOUNT",
    field: "CT - PT.AIR.FARE AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.FARE AMOUNT"],
  },
  {
    headerName: "CT - PT.TOTAL TAXES AMOUNT",
    field: "CT - PT.TOTAL TAXES AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TOTAL TAXES AMOUNT"],
  },
  {
    headerName: "CT - a.FIN.PASSENGER TRANSPORT ADDENDUM PRESENT",
    field: "CT - a.FIN.PASSENGER TRANSPORT ADDENDUM PRESENT",
    filter: "agTextColumnFilter",
    valueGetter: (p) =>
      p.data["CT - a.FIN.PASSENGER TRANSPORT ADDENDUM PRESENT"],
  },
  {
    headerName: "CT - PT.AIR.CARRIER CODE",
    field: "CT - PT.AIR.CARRIER CODE",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.CARRIER CODE"],
  },
  {
    headerName: "CT - PT.AIR.CITY OF DESTINATION",
    field: "CT - PT.AIR.CITY OF DESTINATION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.CITY OF DESTINATION"],
  },
  {
    headerName: "CT - PT.AIR.CITY OF ORIGIN",
    field: "CT - PT.AIR.CITY OF ORIGIN",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.CITY OF ORIGIN"],
  },
  {
    headerName: "CT - PT.TICKET TYPE",
    field: "CT - PT.TICKET TYPE",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TICKET TYPE"],
  },
  {
    headerName: "CT - PT.TICKET NUMBER",
    field: "CT - PT.TICKET NUMBER",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TICKET NUMBER"],
  },
  {
    headerName: "CT - PT.PASSENGER NAME",
    field: "CT - PT.PASSENGER NAME",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.PASSENGER NAME"],
  },
  {
    headerName: "CT - PT.TRAVEL AGENCY INVOICE NUMBER",
    field: "CT - PT.TRAVEL AGENCY INVOICE NUMBER",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TRAVEL AGENCY INVOICE NUMBER"],
  },
  {
    headerName: "CT - PT.DOMESTIC SWITCH",
    field: "CT - PT.DOMESTIC SWITCH",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.DOMESTIC SWITCH"],
  },
  {
    headerName: "CT - TAF.TRAVEL AGENCY SEQUENCE NUMBER",
    field: "CT - TAF.TRAVEL AGENCY SEQUENCE NUMBER",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - TAF.TRAVEL AGENCY SEQUENCE NUMBER"],
  },
  {
    headerName: "CT - PT.AIR.TAX AMOUNT",
    field: "CT - PT.AIR.TAX AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.TAX AMOUNT"],
  },
  {
    headerName: "CT - PT.AIR.FEE AMOUNT",
    field: "CT - PT.AIR.FEE AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.AIR.FEE AMOUNT"],
  },
  {
    headerName: "CT - PT.TAX.DISCOUNT AMOUNT",
    field: "CT - PT.TAX.DISCOUNT AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TAX.DISCOUNT AMOUNT"],
  },
  {
    headerName: "CT - PT.TAX.NET AMOUNT",
    field: "CT - PT.TAX.NET AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TAX.NET AMOUNT"],
  },
  {
    headerName: "CT - PT.TOTAL FARE AMOUNT",
    field: "CT - PT.TOTAL FARE AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TOTAL FARE AMOUNT"],
  },
  {
    headerName: "CT - PT.TAX.TAXABLE AMOUNT",
    field: "CT - PT.TAX.TAXABLE AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.TAX.TAXABLE AMOUNT"],
  },
  {
    headerName: "CT - FIN.EXPENSE DESCRIPTION",
    field: "CT - FIN.EXPENSE DESCRIPTION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.EXPENSE DESCRIPTION"],
  },
  {
    headerName: "CT - FLT.ITEM DESCRIPTION",
    field: "CT - FLT.ITEM DESCRIPTION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FLT.ITEM DESCRIPTION"],
  },
  {
    headerName: "CT - FIN.ADJUSTMENT DESCRIPTION",
    field: "CT - FIN.ADJUSTMENT DESCRIPTION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.ADJUSTMENT DESCRIPTION"],
  },
  {
    headerName: "CT - TAF.DESCRIPTION/TYPE",
    field: "CT - TAF.DESCRIPTION/TYPE",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - TAF.DESCRIPTION/TYPE"],
  },
  {
    headerName: "CT - TAF.FEE",
    field: "CT - TAF.FEE",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - TAF.FEE"],
  },
  {
    headerName: "CT - TAF.FEE SIGN",
    field: "CT - TAF.FEE SIGN",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - TAF.FEE SIGN"],
  },
  {
    headerName: "CT - TAF.RATE",
    field: "CT - TAF.RATE",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - TAF.RATE"],
  },
  {
    headerName: "CT - FIN.PROCESSOR TRANSACTION ID",
    field: "CT - FIN.PROCESSOR TRANSACTION ID",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.PROCESSOR TRANSACTION ID"],
  },
  {
    headerName: "CT - PT.EXCHANGE TICKET NUMBER",
    field: "CT - PT.EXCHANGE TICKET NUMBER",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - PT.EXCHANGE TICKET NUMBER"],
  },
  {
    headerName: "CT - PT.EXCHANGE TICKET AMOUNT",
    field: "CT - PT.EXCHANGE TICKET AMOUNT",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - PT.EXCHANGE TICKET AMOUNT"],
  },
  {
    headerName: "CT - FIN.TRANSACTION REFERENCE NUMBER",
    field: "CT - FIN.TRANSACTION REFERENCE NUMBER",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - FIN.TRANSACTION REFERENCE NUMBER"],
  },
  {
    headerName: "CT - MCH.MERCHANT CATEGORY CODE (MCC)",
    field: "CT - MCH.MERCHANT CATEGORY CODE (MCC)",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["CT - MCH.MERCHANT CATEGORY CODE (MCC)"],
  },
  {
    headerName: "CT - MCH.MCC DESCRIPTION",
    field: "CT - MCH.MCC DESCRIPTION",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["CT - MCH.MCC DESCRIPTION"],
  },
  // WA fields
  {
    headerName: "WA - Agency - Main",
    field: "WA - Agency - Main",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Agency - Main"],
  },
  {
    headerName: "WA - DOC - Number",
    field: "WA - DOC - Number",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - DOC - Number"],
  },
  {
    headerName: "WA - DOC - Date",
    field: "WA - DOC - Date",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - DOC - Date"],
  },
  {
    headerName: "WA - Customer",
    field: "WA - Customer",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Customer"],
  },
  {
    headerName: "WA - Document customer name",
    field: "WA - Document customer name",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Document customer name"],
  },
  {
    headerName: "WA - Prod - Arrival Location",
    field: "WA - Prod - Arrival Location",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Prod - Arrival Location"],
  },
  {
    headerName: "WA - Arrival Country",
    field: "WA - Arrival Country",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Arrival Country"],
  },
  {
    headerName: "WA - Product code description ‘Setup’",
    field: "WA - Product code description ‘Setup’",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Product code description ‘Setup’"],
  },
  {
    headerName: "WA - Prod - Ticket Number with Airline Code",
    field: "WA - Prod - Ticket Number with Airline Code",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Prod - Ticket Number with Airline Code"],
  },
  {
    headerName: "WA - Prod - Booking Reference",
    field: "WA - Prod - Booking Reference",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Prod - Booking Reference"],
  },
  {
    headerName: "WA - Prod - Type (AIR,CAR,HOT,...)",
    field: "WA - Prod - Type (AIR,CAR,HOT,...)",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Prod - Type (AIR,CAR,HOT,...)"],
  },
  {
    headerName: "WA - Passenger First Name",
    field: "WA - Passenger First Name",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Passenger First Name"],
  },
  {
    headerName: "WA - Departure Date",
    field: "WA - Departure Date",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Departure Date"],
  },
  {
    headerName: "WA - Arrival date",
    field: "WA - Arrival date",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Arrival date"],
  },
  {
    headerName: "WA - Payment - UATP Type",
    field: "WA - Payment - UATP Type",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Payment - UATP Type"],
  },
  {
    headerName: "WA - Payment - CC Number",
    field: "WA - Payment - CC Number",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Payment - CC Number"],
  },
  {
    headerName: "WA - Prod - Confirmation no.",
    field: "WA - Prod - Confirmation no.",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Prod - Confirmation no."],
  },
  {
    headerName: "WA - Payment - CC approval code",
    field: "WA - Payment - CC approval code",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Payment - CC approval code"],
  },
  {
    headerName: "WA - Payment - CC UATP approval code",
    field: "WA - Payment - CC UATP approval code",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Payment - CC UATP approval code"],
  },
  {
    headerName: "WA - Auth Code",
    field: "WA - Auth Code",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Auth Code"],
  },
  {
    headerName: "WA - Departure Code",
    field: "WA - Departure Code",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Departure Code"],
  },
  {
    headerName: "WA - Arrival Code",
    field: "WA - Arrival Code",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Arrival Code"],
  },
  {
    headerName: "WA - Hotel - Name",
    field: "WA - Hotel - Name",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Hotel - Name"],
  },
  {
    headerName: "WA - Cust Ref - Department",
    field: "WA - Cust Ref - Department",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - Department"],
  },
  {
    headerName: "WA - Cust Ref - Cost Center",
    field: "WA - Cust Ref - Cost Center",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - Cost Center"],
  },
  {
    headerName: "WA - Cust Ref - Project Number",
    field: "WA - Cust Ref - Project Number",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - Project Number"],
  },
  {
    headerName: "WA - Cust Ref - Employee",
    field: "WA - Cust Ref - Employee",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - Employee"],
  },
  {
    headerName: "WA - Cust Ref - Order Number",
    field: "WA - Cust Ref - Order Number",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - Order Number"],
  },
  {
    headerName: "WA - Cust Ref - CD1",
    field: "WA - Cust Ref - CD1",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - CD1"],
  },
  {
    headerName: "WA - Cust Ref - CD2",
    field: "WA - Cust Ref - CD2",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - CD2"],
  },
  {
    headerName: "WA - Cust Ref - CD3",
    field: "WA - Cust Ref - CD3",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - CD3"],
  },
  {
    headerName: "WA - Cust Ref - CD4",
    field: "WA - Cust Ref - CD4",
    filter: "agTextColumnFilter",
    valueGetter: (p) => p.data["WA - Cust Ref - CD4"],
  },
  {
    headerName: "WA - Gross Amount CCC",
    field: "WA - Gross Amount CCC",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Gross Amount CCC"],
  },
  {
    headerName: "WA - GST CCC",
    field: "WA - GST CCC",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - GST CCC"],
  },
  {
    headerName: "WA - Net Amount CCC",
    field: "WA - Net Amount CCC",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Net Amount CCC"],
  },
  {
    headerName: "WA - TAX CCC",
    field: "WA - TAX CCC",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - TAX CCC"],
  },
  {
    headerName: "WA - Air - Airline",
    field: "WA - Air - Airline",
    filter: "agNumberColumnFilter",
    valueGetter: (p) => p.data["WA - Air - Airline"],
  },
];

const items = [
  { key: "ReconA", label: "CTA vs Agency Recon" },
  { key: "ReconB", label: "Airline & Agency GST Recon" },
];

function ReportTable() {
  const [activeTab, setActiveTab] = useState("ReconA");
  const ref = useRef(null);

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            gap: "16px",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <Typography className="reportTxt">Reports</Typography>
        </div> */}
        <PageHeader
          title="Reconciliation"
          leftActions={
            <Tabs
              className="my-custom-tabs"
              items={items}
              activeKey={activeTab}
              onChange={setActiveTab}
              tabBarStyle={{
                borderBottom: "none",
                margin: 0,
                boxShadow: "none",
              }}
              style={{ border: "none", boxShadow: "none" }}
            />
          }
          rightActions={
            <Button
              size="small"
              style={{ backgroundColor: "#0A8394", color: "white" }}
            >
              Download Report
            </Button>
          }
        />
        <div style={{ flex: 1, marginTop: "16px", height: "100%" }}>
          {activeTab === "ReconA" ? (
            <AgTableClient
              columnDefs={columnDefs1}
              rowData={sampleReconA}
              ref={ref}
              groupPanel
            />
          ) : (
            <div style={{ flex: 1, marginTop: "16px", height: "100%" }}>
              <AgTableClient
                columnDefs={columnDefs2}
                rowData={sampleReconB}
                ref={ref}
                groupPanel
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ReportTable;
